










import { Component, Vue } from 'vue-property-decorator';
import UpdateInventory from './updateInventory/updateInventory.vue';

@Component({
  components: {
    UpdateInventory
  }
})
export default class BatchOperation extends Vue {
  activeName: string = 'updateInventory';//显示哪个模块
  /* 预留切换事件 */
  handleClick(val){}
}
